<template>
  <v-fade-transition>
    <v-overlay v-if="loading" absolute z-index="100" :color="overlayColor">
      <v-progress-circular
        absolute
        indeterminate
        class="darken-1 loader"
        :size="size"
        :color="loaderColor"
      />
    </v-overlay>
  </v-fade-transition>
</template>

<script>
/**
 * Loader to be used thourghout the core module
 * @author {Mohit Guleria}
 */
export default {
  name: "Loader",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    /**
     * Displays loader to the user
     */
    loading: { type: Boolean, default: false },
    /**
     * Size of the loader
     */
    size: { type: String, default: "65" },
    /**
     * Color of loader
     */
    loaderColor: { type: String, default: "#F9F9F9" },
    /**
     * Loader overlay color
     */
    overlayColor: { type: String, defaultStatus: "white" }
  }
};
</script>